"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderSearchButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const native_base_1 = require("native-base");
const react_1 = require("react");
const native_1 = require("@react-navigation/native");
const react_redux_1 = require("react-redux");
const colors_1 = require("../common/colors");
const AppButton_1 = __importDefault(require("../component/AppButton"));
const AppText_1 = require("../component/AppText");
const useDevice_1 = require("../hooks/useDevice");
const character_1 = require("../slices/character");
const react_native_1 = require("react-native");
const HeaderSearchButton = (props) => {
    const { activeCategory, ...iconButtonProps } = props;
    return ((0, jsx_runtime_1.jsx)(native_base_1.IconButton, { 
        // borderRadius={15}
        height: react_native_1.Platform.OS === 'web' ? 8 : 30, onPress: () => {
            // navigate("DiscoverSearch", { activeCategory });
        }, width: react_native_1.Platform.OS === 'web' ? 8 : 2, padding: react_native_1.Platform.OS === 'web' ? 0 : undefined, _pressed: {
            backgroundColor: colors_1.Colors.DARK_700,
        }, variant: "ghost", icon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSearch, color: colors_1.Colors.white, size: 24 }), ...iconButtonProps }, "searchBtn"));
};
exports.HeaderSearchButton = HeaderSearchButton;
/**
 *
 * @returns
 */
const HeaderSearchButtons = () => {
    const { isOpen, onOpen, onClose } = (0, native_base_1.useDisclose)();
    const { isTabOrDesktopDevice, deviceWidth } = (0, useDevice_1.useDevice)();
    const onVisibilityChange = (0, react_1.useCallback)(async () => {
        onOpen();
        //onVisibilityChange
    }, []);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [categoryList, setCategoryList] = (0, react_1.useState)([]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const route = (0, native_1.useRoute)();
    const selectedCat = route?.params?.category;
    /**
     *
     */
    const getCategoryList = (0, react_1.useCallback)(async () => {
        setIsLoading(true);
        let response = await dispatch((0, character_1.categoryListAsync)());
        console.log("Get categories...categoryListAsync");
        //one retry on fail
        if (!response?.payload?.success) {
            response = await dispatch((0, character_1.categoryListAsync)());
        }
        let storedCategories = response?.payload?.data || [];
        // Append "All" category to API list
        if (!storedCategories?.find((storedCat) => storedCat.toLowerCase() === "all")) {
            storedCategories.unshift("All");
        }
        console.log("storedCategories:", storedCategories);
        setCategoryList(storedCategories);
        setIsLoading(false);
    }, []);
    (0, react_1.useEffect)(() => {
        getCategoryList();
    }, []);
    if (isLoading)
        return (0, jsx_runtime_1.jsx)(native_base_1.HStack, { space: 8, height: 12 });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(native_base_1.HStack, { space: 5, children: [(0, jsx_runtime_1.jsx)(native_base_1.IconButton, { 
                        // borderRadius={15}
                        height: 30, onPress: onVisibilityChange, width: 2, _pressed: {
                            backgroundColor: colors_1.Colors.DARK_700,
                        }, variant: "ghost", icon: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSlidersSimple, color: colors_1.Colors.white, size: 24 }) }, "filterBtn"), (0, jsx_runtime_1.jsx)(exports.HeaderSearchButton, { activeCategory: "characters" })] }), (0, jsx_runtime_1.jsx)(native_base_1.Actionsheet, { isOpen: isOpen, onClose: onClose, useRNModal: true, width: isTabOrDesktopDevice ? "60%" : "100%", bottom: isTabOrDesktopDevice ? "10%" : 0, left: isTabOrDesktopDevice ? "20%" : 0, children: (0, jsx_runtime_1.jsx)(native_base_1.Actionsheet.Content, { bg: colors_1.Colors.DARK_600, rounded: 16, children: (0, jsx_runtime_1.jsxs)(native_base_1.VStack, { textAlign: "left", width: deviceWidth - 30, padding: 1, space: 4, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppHeading, { color: colors_1.Colors.white, fontSize: 24, 
                                // textAlign={"left"}
                                width: "100%", children: "Categories" }), (0, jsx_runtime_1.jsx)(native_base_1.HStack, { space: 4, width: (deviceWidth * 90) / 100, flexWrap: "wrap", alignItems: "flex-start", alignContent: "flex-start", alignSelf: "flex-start", children: categoryList?.map((category) => ((0, jsx_runtime_1.jsx)(AppButton_1.default, { color: colors_1.Colors.FAILURE, borderRadius: 30, mb: 5, backgroundColor: selectedCat?.toLowerCase() === category?.toLowerCase()
                                        ? colors_1.Colors.PRIMARY_300
                                        : colors_1.Colors.PRIMARY_700, borderColor: colors_1.Colors.PRIMARY_300, borderWidth: 1, onPress: () => {
                                        onClose();
                                        // navigate("Characters", { category });
                                    }, children: category }, category))) }), (0, jsx_runtime_1.jsx)(AppButton_1.default
                            // colorScheme="danger"
                            , { 
                                // colorScheme="danger"
                                variant: "outline", _text: { color: colors_1.Colors.PRIMARY_200 }, mt: 3, borderRadius: 20, borderColor: colors_1.Colors.DARK_500, _pressed: {
                                    backgroundColor: colors_1.Colors.DARK_600,
                                }, onPress: async () => {
                                    onClose();
                                }, children: "Gotcha" })] }) }) }, "userFilterSelect")] }));
};
exports.default = HeaderSearchButtons;
